import { render } from "./PermissionUpdate.vue?vue&type=template&id=a2eb2bec&scoped=true"
import script from "./PermissionUpdate.vue?vue&type=script&lang=js"
export * from "./PermissionUpdate.vue?vue&type=script&lang=js"

import "./PermissionUpdate.vue?vue&type=style&index=0&id=a2eb2bec&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2eb2bec"]])

export default __exports__